import { render } from "./TheServiceComponent.vue?vue&type=template&id=6f253bbe&scoped=true"
import script from "./TheServiceComponent.vue?vue&type=script&lang=js"
export * from "./TheServiceComponent.vue?vue&type=script&lang=js"

import "./TheServiceComponent.vue?vue&type=style&index=0&id=6f253bbe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f253bbe"]])

export default __exports__